<template>
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 1.58228H1L9 11.0423V17.5823L13 19.5823V11.0423L21 1.58228Z" stroke="#6782F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>